module.exports = {
  cxApiParams: {
    anonClientId: "cr_web",
  },
  datadog: {
    applicationId: "cd93f32f-4608-4162-b03d-f322ebf425e3",
    clientToken: "pub02611aa18871dcd1cce1d524a76e4659",
    site: "us5.datadoghq.com",
    service: "cr-news",
    sessionSampleRate: 20,
    premiumSampleRate: 0,
    trackUserInteractions: true,
    defaultPrivacyLevel: "mask-user-input",
  },
  // features should match the ones from cx-web
  features: {
    storageKey: "staging_efg_state",
    flags: {
      oneTrust:
        "6ea1aab70e1211c191db6aada783cca47fd0bc644a9d6921831a10e5f9e63dae",
    },
  },
  oneTrust: {
    domainScript: "9470b86f-5b87-4646-a4f7-2f2916b2a883-test",
  },
};
